import React from 'react';
import { StyleSheet, Button, TouchableOpacity } from 'react-native';

import FormField from 'ui/form/FormField';
import Item from '../Item';
import { type TableType } from 'types/Table';

const styles = StyleSheet.create({
  touchContent: {
    width: '100%',
  },
});

interface Props {
  item: TableType;
  setFieldValue?: (item: TableType) => void;
  expanded: boolean;
  setExpanded: (isExpanded: boolean) => void;
}

const ItemForm: React.FC<Props> = ({
  item,
  setFieldValue,
  expanded,
  setExpanded,
}) => {
  return (
    <>
      <TouchableOpacity
        onPress={() => {
          setExpanded(!expanded);
          if (setFieldValue !== undefined) {
            setFieldValue(item);
          }
        }}
        style={styles.touchContent}
      >
        <Item item={item} />
      </TouchableOpacity>
      <Button
        title="Select"
        onPress={() => {
          setExpanded(!expanded);
          if (setFieldValue !== undefined) {
            setFieldValue(item);
          }
        }}
      />
    </>
  );
};

export default FormField(ItemForm);
